// client/plugins/EnsureDocNodeAttrs.ts
import { Plugin } from "prosemirror-state";
import "prosemirror-view";
function EnsureDocNodeAttrs(attrs) {
  return new Plugin({
    view(editorView) {
      for (const key of Object.keys(attrs)) {
        const value = attrs[key];
        if (!value)
          continue;
        setDocAttribute({ view: editorView, key, value });
      }
      return {
        update(view) {
        }
      };
    }
  });
}
function setDocAttribute({ view, key, value }) {
  view.state.doc.attrs[key] = value;
}
export {
  EnsureDocNodeAttrs,
  setDocAttribute
};
